<template>
  <div
    ref="reference"
    class="dsf-sc-super-search-input"
    v-clickoutside="() => toggleDropDownVisible(false)"
    @click="() => toggleDropDownVisible()">
    <el-input
      ref="input"
      v-model="value"
      :placeholder="placeholder"
      :validate-event="false"
      :class="{ 'is-focus': dropDownVisible }"
      readonly
      @focus="handleFocus"
      @blur="handleBlur">
      <template #suffix>
        <i class="el-icon-more"></i>
      </template>
    </el-input>
    <transition name="el-zoom-in-top" @after-leave="handleDropdownLeave">
      <div
        v-show="dropDownVisible"
        ref="popper"
        class="el-popper dsf-sc-super-search-input__dropdown">
        <header>
          <span>输入多行文本</span>
        </header>
        <main>
          <el-input
            ref="textarea"
            v-model="downValue"
            :rows="7"
            :placeholder="placeholder"
            resize="none"
            type="textarea"
          />
        </main>
        <footer>
          <dsf-button size="small" type="plain" @click="toggleDropDownVisible(false)">取消</dsf-button>
          <dsf-button size="small" @click="sure">确定</dsf-button>
        </footer>
      </div>
    </transition>
  </div>
</template>

<script>
const Popper = ELEMENT.Popover.mixins[0];
const Clickoutside = ELEMENT.Cascader.directives.Clickoutside;

const PopperMixin = {
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    appendToBody: Popper.props.appendToBody,
    visibleArrow: {
      type: Boolean,
      default: true
    },
    arrowOffset: Popper.props.arrowOffset,
    offset: Popper.props.offset,
    boundariesPadding: Popper.props.boundariesPadding,
    popperOptions: Popper.props.popperOptions
  },
  methods: Popper.methods,
  data: Popper.data,
  beforeDestroy: Popper.beforeDestroy
};

export default {
  name: "DsfScSuperSearchInput",
  mixins: [PopperMixin],
  directives: { Clickoutside },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    }
  },
  data() {
    return {
      dropDownVisible: false,
      downValue: ''
    }
  },
  methods: {
    handleFocus(e) {
      this.$emit('focus', e);
    },
    handleBlur(e) {
      this.$emit('blur', e);
    },
    toggleDropDownVisible(visible) {
      const { dropDownVisible } = this;
      const { input } = this.$refs;
      visible = dsf.isDef(visible) ? visible : !dropDownVisible;
      if (visible !== dropDownVisible) {
        this.dropDownVisible = visible;
        if (visible) {
          this.downValue = this.value;
          this.$nextTick(() => {
            this.updatePopper();
            this.$refs.textarea.focus();
          });
        }
        input.$refs.input.setAttribute('aria-expanded', visible);
        this.$emit('visible-change', visible);
      }
    },
    handleDropdownLeave() {
      this.doDestroy();
    },
    sure() {
      this.$emit('input', this.downValue);
      this.toggleDropDownVisible(false);
    }
  }
}
</script>